module.exports = __webpack_public_path__ + "img/labs2_2.4a1279ef.svg";